export default
  [
    {
      path: '',
      redirect: 'personAndOrganization'
    },
    // 人员及组织架构
    {
      path: 'personAndOrganization',
      name: 'personAndOrganization',
      component: () => import('@/page/systemPersonnelManagement'),
      meta: { openKeyName: '系统管理', selectKeyUrl: 'personAndOrganization' }
    },
    // 角色管理
    {
      path: 'roleManagement',
      name: 'roleManagement',
      component: () => import('@/page/systemPersonnelManagement/roleManagement'),
      meta: { openKeyName: '系统管理', selectKeyUrl: 'roleManagement' }
    },

    // 货种字典
    {
      path: 'goodsDictionary',
      name: 'goodsDictionary',
      component: () => import('@/page/systemPersonnelManagement/goodsName'),
      meta: { openKeyName: '系统管理', selectKeyUrl: 'goodsDictionary' }
    },
    // 客服设置
    {
      path: 'customerServiceSettings',
      name: 'customerServiceSettings',
      component: () => import('@/page/systemPersonnelManagement/customerServiceSettings'),
      meta: { openKeyName: '系统管理', selectKeyUrl: 'customerServiceSettings' }
    },
    // v1.1.0 港口字典
    {
      path: 'portDictionary',
      name: 'portDictionary',
      component: () => import('@/page/systemPersonnelManagement/portDictionary'),
      meta: { openKeyName: '系统管理', selectKeyUrl: 'portDictionary' }
    },
    // 税率字典
    {
      path: 'taxRateDictionary',
      name: 'taxRateDictionary',
      component: () => import('@/page/systemPersonnelManagement/taxRateDictionary'),
      meta: { openKeyName: '系统管理', selectKeyUrl: 'taxRateDictionary' }
    },
    // 验证码
    {
      path: 'smsRecord',
      name: 'smsRecord',
      component: () => import('@/page/systemPersonnelManagement/smsRecord'),
      meta: { openKeyName: '系统管理', selectKeyUrl: 'smsRecord' }
    },
  ]



// WEBPACK FOOTER //
// ./src/router/systemPersonnelManagement/index.js